<div class="layout-container">
    <div class="layout-content-wrapper" style="padding:0px;margin:0px;">
        <div class="layout-content" style="display:flex;padding:0px;margin:0px;">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>